import { ISurveyQuestionItemDTO } from '../../major_explorer_interface';

export class SurveyQuestionGenericController {
  private mode: string;
  private item: ISurveyQuestionItemDTO;
}

export class SurveyQuestionGenericComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_question_generic/survey_question_generic.html';
  public controller: any = SurveyQuestionGenericController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    mode: '@',
    item: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question_generic/survey_question_generic.ts